import script from "./center-default.vue?vue&type=script&setup=true&lang=js"
export * from "./center-default.vue?vue&type=script&setup=true&lang=js"

import "./center-default.vue?vue&type=style&index=0&id=18e77f79&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e77f79"]])

export default __exports__